export const EXLY_EMPTY_STATE_SECONDARY_CTA_VARIANTS = {
  secondary: "secondary",
  learn_more: "learn_more",
  preview_image: "preview_image",
};
